/**
 * 签到方式枚举
 *
 * - SCAN: 扫码签到 - 嘉宾扫描现场二维码完成签到
 * - VERIFY: 嘉宾验证签到 - 嘉宾通过手机号+邀约码验证后签到
 * - BATCH: 批量签到 - 管理员批量导入签到（适用于团体到达场景）
 * - ASSISTANT: 助手代签 - 助手账号代为嘉宾签到
 * - LIAISON: 联络员签到 - 联络员确认嘉宾到场后签到
 */
export enum CheckInMethod {
  SCAN = 'SCAN',
  VERIFY = 'VERIFY',
  BATCH = 'BATCH',
  ASSISTANT = 'ASSISTANT',
  LIAISON = 'LIAISON',
}

/** 所有签到方式值的数组 */
export const CheckInMethodValues: string[] = Object.values(CheckInMethod);

/** 签到方式中文标签映射 */
export const CheckInMethodLabels: Record<CheckInMethod, string> = {
  [CheckInMethod.SCAN]: '扫码签到',
  [CheckInMethod.VERIFY]: '嘉宾验证签到',
  [CheckInMethod.BATCH]: '批量签到',
  [CheckInMethod.ASSISTANT]: '助手代签',
  [CheckInMethod.LIAISON]: '联络员签到',
};
